/**
 * useDisableCheckouts
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import DisableCheckoutsContext from './disable-checkouts-context'

const useDisableCheckouts = () => {
  const context = useContext(DisableCheckoutsContext)
  return context
}

export default useDisableCheckouts
